import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/programare/components/AppointmentsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentsStateProvider"] */ "/app/apps/nextjs/src/hooks/useAppointments.tsx");
